<!-- 采购信息 -->
<template>
  <div>
    <QS-h4-title title="采购信息"/>
    <el-form :model="purchaseDateObj" :inline="true">
      <el-form-item :label="'签署日期' + columnSeparator" prop="signDate">
        <el-date-picker
          v-model="purchaseDateObj.signDate"
          type="date"
          :clearable="false"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd HH:mm:ss"
          placeholder="选择日期"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item
        :label="'付款起止日期' + columnSeparator"
        prop="startStopDate"
      >
        <el-date-picker
          v-model="purchaseDateObj.startStopDate"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd HH:mm:ss"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :clearable="false"
          @change="startStopDateChange"
          :default-time="['00:00:00', '23:59:59']"
        >
        </el-date-picker>
      </el-form-item>
  </el-form>
  </div>
</template>
<script>
import moment from 'moment'

export default {
  name: 'PurchaDate',
  data() {
    return {
      purchaseDateObj: {
        signDate: moment(new Date()).format('YYYY-MM-DD 00:00:00'), // 签署日期
        startStopDate: [], // 起止日期
        startDate: '', // 计租开始日期
        endDate: '', // 计租结束日期
      },
    }
  },
  watch: {
    // 因为data中设置了默认值，所以需要更新父组件的signDate(签署日期)
    'purchaseDateObj.signDate': {
      handler() {
        this.startStopDateChange()
      },
      immediate: true,
    },
  },
  mounted() {
  },
  methods: {
    // 收款起止日期change
    startStopDateChange() {
      this.purchaseDateObj.startDate = this.purchaseDateObj.startStopDate[0]
      this.purchaseDateObj.endDate = this.purchaseDateObj.startStopDate[1]
      // 表单重新计算总期数
      this.$emit('updateDate', this.purchaseDateObj)
    },
  },
}
</script>
